import $ from 'jquery';
const collapseDisplayed = ['xs'];


export class FakeWaffle {
    public currentPosition:string = '';

    constructor() {
        $(window).resize(() => { this.checkResize(); });
    }

    public responsiveTabs():void {
        this.currentPosition = 'tabs';
        let activeTab:string = '';

        let hidden:string = '';
        let visible:string = '';
        collapseDisplayed.forEach(value => {
            hidden += ' hidden-' + value;
            visible += ' visible-' + value;
        });

        const tabGroups = $('.nav-tabs.responsive');
        $.each(tabGroups, (index, tabGroup) => {
            const $tabGroup:any = $(tabGroup);
            if ($tabGroup.attr('id') === undefined) {
                $tabGroup.attr('id', 'tabs-' + index);
            }

            const collapseDiv:any = $('<div></div>', {
                class: 'panel-group responsive' + visible,
                id: 'collapse-' + $tabGroup.attr('id')
            });

            const tabs:any = $tabGroup.find('li a');
            $.each(tabs, (_, tab) => {
                const $this = $(tab);
                const oldLinkClass = $this.attr('class') === undefined ? '' : $this.attr('class');
                let newLinkClass = 'accordion-toggle';
                if (oldLinkClass.length > 0) {
                    newLinkClass += ' ' + oldLinkClass;
                }

                let oldParentClass = $this.parent().attr('class') === undefined ? '' : $this.parent().attr('class');
                let newParentClass = 'panel panel-default';
                if (oldParentClass.length > 0) {
                    oldParentClass = oldParentClass.replace(/\bactive\b/g, '');
                    newParentClass += ' ' + oldParentClass;
                    newParentClass = newParentClass.replace(/\s{2,}/g, ' ');
                    newParentClass = newParentClass.replace(/^\s+|\s+$/g, '');
                }

                const newHash = $this.get(0).hash.replace('#', 'collapse-');
                if ($this.parent().hasClass('active')) {
                    activeTab = '#' + newHash;
                }

                collapseDiv.append(
                    $('<div>').attr('class', newParentClass).html(
                        $('<div>').attr('class', 'panel-heading').html(
                            $('<h4>').attr('class', 'panel-title').html(
                                $('<a>', {
                                    class: newLinkClass,
                                    'data-toggle': 'collapse',
                                    'data-parent': '#collapse-' + $tabGroup.attr('id'),
                                    href: '#' + newHash,
                                    html: $this.html()
                                })
                            )
                        )
                    ).append($('<div>', { id: newHash, class: 'panel-collapse collapse' }))
                );
            });

            $tabGroup.next().after(collapseDiv);
            $tabGroup.addClass(hidden);
            $('.tab-content.responsive').addClass(hidden);

            if (activeTab) {
                $(activeTab).collapse('show');
            }
        });

        this.bindTabToCollapse();
        this.checkResize();
    }

   private checkResize():void {
        const $responsive = $('.panel-group.responsive');
        if ($responsive.is(':visible') === true && this.currentPosition === 'tabs') {
            this.tabToPanel();
            this.currentPosition = 'panel';
        } else if ($responsive.is(':visible') === false && this.currentPosition === 'panel') {
            this.panelToTab();
            this.currentPosition = 'tabs';
        }
    }

    private tabToPanel():void {
        const tabGroups = $('.nav-tabs.responsive');
        $.each(tabGroups, (_, tabGroup) => {
            const tabContents = $(tabGroup).next('.tab-content').find('.tab-pane');
            $.each(tabContents, (_, tabContent) => {
                const destinationId = $(tabContent).attr('id').replace(/^/, '#collapse-');
                $(tabContent).removeClass('tab-pane').addClass('panel-body fw-previous-tab-pane').appendTo($(destinationId));
            });
        });
    }

    private panelToTab():void {
        const panelGroups = $('.panel-group.responsive');
        $.each(panelGroups, (_, panelGroup) => {
            const destinationId = $(panelGroup).attr('id').replace('collapse-', '#');
            const destination = $(destinationId).next('.tab-content')[0];
            const panelContents = $(panelGroup).find('.panel-body.fw-previous-tab-pane');
            panelContents.removeClass('panel-body fw-previous-tab-pane').addClass('tab-pane').appendTo($(destination));
        });
    }

    private bindTabToCollapse():void {
        const tabs = $('.nav-tabs.responsive').find('li a');
        const collapse = $('.panel-group.responsive').find('.panel-collapse');
        tabs.on('shown.bs.tab', e => {
            if (this.currentPosition === 'tabs') {
                $(e.currentTarget.hash.replace(/#/, '#collapse-')).collapse('show');
                if (e.relatedTarget) {
                    $(e.relatedTarget.hash.replace(/#/, '#collapse-')).collapse('hide');
                }
            }
        });
        collapse.on('shown.bs.collapse', e => {
            if (this.currentPosition === 'panel') {
                const current = $(e.target).attr('id').replace(/collapse-/g, '#');
                $('a[href="' + current + '"]').tab('show');
                const panelGroup = $(e.currentTarget).closest('.panel-group.responsive');
                $(panelGroup).find('.panel-body').removeClass('active');
                $(e.currentTarget).find('.panel-body').addClass('active');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/fakewaffle-ang7.ts